import { Flex, Radio, theme, Label } from "@xometry/xometry_loft";
import { UnitOfMeasurement } from "../../schema/generated/schema";

const defaultProps = {
  scale: "small",
  defaultValue: UnitOfMeasurement.Mm,
  labels: {
    [UnitOfMeasurement.Mm]: UnitOfMeasurement.Mm.toLowerCase(),
    [UnitOfMeasurement.In]: UnitOfMeasurement.In.toLowerCase(),
  },
};

type FileUnitRadioGroupProps = {
  name: string;
  onChange: (unit: UnitOfMeasurement) => void;
  defaultValue?: UnitOfMeasurement;
  scale?: "small" | "medium";
  labels?: Record<UnitOfMeasurement, string>;
};

const FileUnitRadioGroup: React.FC<FileUnitRadioGroupProps> = ({
  name,
  onChange,
  defaultValue,
  scale,
  labels,
}) => {
  return (
    <Flex marginY={theme.space[1]}>
      {Object.values(UnitOfMeasurement).map(unit => {
        return (
          <Flex
            paddingX={theme.space[1]}
            flex={1}
            alignItems="center"
            key={`${name}-radio-${unit}`}
          >
            <Radio
              defaultChecked={defaultValue === unit}
              name={`file-${name}-unit`}
              value={unit}
              id={unit}
              scale={scale}
              enterKeyHint="Radio"
              onChange={event => {
                event.stopPropagation();
                const isChecked = !!event.currentTarget?.checked;
                if (isChecked && typeof onChange === "function") {
                  onChange(unit);
                }
              }}
            />
            <Label htmlFor={unit} marginBottom={0}>
              {labels ? labels[unit] : unit}
            </Label>
          </Flex>
        );
      })}
    </Flex>
  );
};

FileUnitRadioGroup.defaultProps =
  defaultProps as Partial<FileUnitRadioGroupProps>;

export default FileUnitRadioGroup;
